// Twodata.js
const dataArray = [
    { id: 1, text: "New Phantom GX", imageUrl: "https://images.unsplash.com/photo-1554139844-af2fc8ad3a3a?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", buttonText: "Shop Now" },
    { id: 2, text: "New Phantom FR", imageUrl: "https://images.unsplash.com/photo-1593419528756-3cdfa1615b86?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", buttonText: "Shop Now" }
  ];
  
  export default dataArray;
  